import { typeBenefits } from "../constant/default";

const codeBenefit2Title = function (code) {
  if (typeBenefits?.length > 0 && code) {
    const obj = typeBenefits.find((e) => e.id === code);
    if (obj?.title) return obj.title;
  }
  return "";
};

export default codeBenefit2Title;
